module.exports = __webpack_public_path__ + "static/media/Apple SDGothicNeoSB00-01.deb0d6cd.svg";